import styled from 'styled-components'

export const TableContainer = styled.main`
    width: 100%;
`

export const Table = styled.table`
    width: 100%;

    thead {
        border-bottom: 1px solid var(--gray-400);

        tr th {
            padding: 20px;
            font-size: 14px;
            font-weight: 700;

            a {
                text-decoration: none;
                user-select: none;

                color: var(--gray-800);
            }
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid var(--gray-400);

            &:hover {
                background-color: var(--blue-200);
            }

            td {
                min-width: 130px;
                max-width: 250px;
            }
        }
    }
`

export const NewReportCircle = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 9999px;
    background-color: var(--warn);
`

export const LoadMoreButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    padding: 30px 0;

    span {
        font-size: 13px;
        font-weight: 400;
    }

    button {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        padding: 6px;

        width: 242px;
        border: none;
        border-radius: 3px;

        color: white;
        background-color: var(--blue-500);

        &:hover {
            opacity: 0.8;
        }

        i {
            font-size: 16px;
        }

        span {
            font-weight: 500;
        }
    }
`
